<template>
  <div class="home-page">
    <div>
      <div
        class="header-main web"
        :style="{
          backgroundImage:
            'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
        }"
      >
        <ul class="link-list">
          <div class="header-img">
            <img
              src="../assets/img/emotibot_logo.c18e704.png"
              class="logo"
              alt=""
            />
          </div>
          <li class="">
            <span class="active">首页</span>
            <!---->
          </li>
          <li class="" @click="downloadIndex(1)">
            <span class="">软件下载</span>
          </li>
          <li class="hasSlide" @click="downloadIndex(2)">
            <span class="">关于我们</span>
          </li>
        </ul>
      </div>
      <div
        class="wrap"
        :style="{
          backgroundImage:
            'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
        }"
      >
        <div class="wrap-nav">
          <img
            src="../assets/img/emotibot_logo.c18e704.png"
            alt=""
            style="width: 128px; padding-top: 30px; height: 128px"
          />
          <span> <i class="el-icon-menu" @click="openList()"></i></span>
        </div>
        <ul class="wrap-nav-list" :style="menuShowFlag">
          <li>
            <span>首页</span>
            <!---->
          </li>
          <li @click="downloadIndex(1)">
            <span>软件下载</span>
            <!---->
          </li>
          <li @click="downloadIndex(2)">
            <span>关于我们</span>
            <!---->
          </li>
        </ul>
      </div>
    </div>

    <div class="home-page-banner">
      <el-carousel :interval="5000" arrow="always" height="550px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="carousel-inner">
            <img
              :src="require('../assets/images/banner/' + item.imgUrl + '.png')"
              alt=""
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="home-page-banner_warp">
      <el-carousel :interval="5000" arrow="always" height="550px">
        <el-carousel-item v-for="(item, index) in bannerwrapList" :key="index">
          <div class="carousel-inner">
            <img
              :src="require('../assets/images/banner/' + item.imgUrl + '.png')"
              alt=""
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="product-bg">
      <div class="content-center content-center-product">
        <div class="product-desc">
          <p class="wrap product-title-wrap">OP六大产品组成</p>
          <div class="title-box web">
            <p class="title-first">OP六大产品组成</p>
          </div>
          <ul class="product-item">
            <li>
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img src="../assets/images/icon/OP BUILDER.png" alt="" />
                    <p class="title web">OP BUILDER</p>
                  </div>
                  <div>
                    <p class="title wrap">OP BUILDER</p>
                    <p class="second_title web">机器人设计器</p>
                    <p class="desc">
                      是让用户创建机器人流程的图形化工具，支持发布2种不同颗粒度的流程。制定详细的指令并将它们发布到机器人上，让用户通过可视化的UI拖动创建机器人流程。
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img src="../assets/images/icon/OP ROBOTS.png" alt="" />
                    <p class="title web">OP ROBOTS</p>
                  </div>
                  <div>
                    <p class="title wrap">OP ROBOTS</p>
                    <p class="second_title web">机器人</p>
                    <p class="desc">
                      位于虚拟化或物理环境中，与业务应用程序直接交互。根据指令，批处理模式高效、全自动运行大量流程化事物。支持单机并发模式。
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img src="../assets/images/icon/OP CONTROLLER.png" alt="" />
                    <p class="title web">OP CONTROLLER</p>
                  </div>
                  <div>
                    <p class="title wrap">OP CONTROLLER</p>
                    <p class="second_title web">机器人控制器</p>
                    <p class="desc">
                      企业体系结构服务器平台，可集中调度、排列机器人工作，管理机器人负载、通用功能、日志记录、报告；对机器人授权、部署、管理和监控等。
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li style="display:none">
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img src="../assets/images/icon/AI_1.png" alt="" />
                    <p class="title web">AI图形处理产品</p>
                  </div>
                  <div>
                    <p class="title wrap">AI图形处理产品</p>
                    <p class="second_title web">AI图形处理产品</p>
                    <p class="desc">
                      根据图形可视化分析，自动产生匹配插值算法。具有，快速，高效，高启发性，并行性等特点。
                      重而达到精准定位，具体细节描绘等与众不同的特点。
                      并且，吸收各种图形处理产品的优势，摒弃色阶，色域转换丢失等弊端，形成自主的独立完整体系
                      。是一款功能强大的图形处理产品。
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img src="../assets/images/icon/AI_2.png" alt="" />
                    <p class="title web">AI数据模型统计预测算法工具</p>
                  </div>
                  <div>
                    <p class="title wrap">AI数据模型统计预测算法工具</p>
                    <p class="second_title web">AI数据模型统计预测算法工具</p>
                    <p class="desc">
                      不仅仅包含差分分析，统计分析，线性函数等。还加入机器自学习模块。二维，三维可视化图形分析模块等。使得用户体验更上一层。同时，预测算法工具，在结合大数据，人工智能等技术领域，多维度的强大加持下。
                      使得本工具在应对各种复杂问题，困难问题，决策问题等，都拥有极好的表现。同时，兼顾用户使用体验。使得产品更人性化。
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div class="flex-header">
                  <div class="icon-name">
                    <img src="../assets/images/icon/AI_3.png" alt="" />
                    <p class="title web">AI自然语言处理产品</p>
                  </div>
                  <div>
                    <p class="title wrap">AI自然语言处理产品</p>
                    <p class="second_title web">AI自然语言处理产品</p>
                    <p class="desc">
                      集成句法语义分析，信息抽取，文本挖掘，机器翻译，信息检索等NLP常见能力，并且满足用户高并发，多线程等需求。对于处理强大文本以及可视化文字分析方面都拥有强大优势。
                      在大规模文档中，表现尤为突出。同时兼顾神经网络的方法，使得产品在用户体验，满意度等方面都领先其他同类产品一筹。
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content-center tech web">
      <div class="bg-circle"></div>
      <div class="title-box">
        <p class="title-first">核心技术，理念</p>
        <p class="title-third"></p>
      </div>
      <ul class="flex-item">
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/YJ.png" alt="" />
            <div>
              <p class="title-second">愿景</p>
              <p class="line"></p>
              <p class="content">成为RPA行业的擎天柱</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/SM.png" alt="" />
            <div>
              <p class="title-second">使命</p>
              <p class="line"></p>
              <p class="content">普及数字化员工</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/HX.png" alt="" />
            <div>
              <p class="title-second">核心价值观</p>
              <p class="line"></p>
              <p class="content">产品卓越，规范管理，开放合作，持续创新</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
      </ul>
    </div>
    <div class="tech-wrap wrap">
      <p class="tech-title1">核心技术，理念</p>
      <p class="tech-title2"></p>
      <ul>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/YJ.png" alt="" />
            <div>
              <p class="title-second">愿景</p>
              <p class="line"></p>
              <p class="content" style="font-size: 12px">成为RPA行业的擎天柱</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/SM.png" alt="" />
            <div>
              <p class="title-second">使命</p>
              <p class="line"></p>
              <p class="content" style="font-size: 12px">普及数字化员工</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/HX.png" alt="" />
            <div>
              <p class="title-second">核心价值观</p>
              <p class="line"></p>
              <p class="content" style="font-size: 12px; width: 300px">
                产品卓越，规范管理，开放合作，持续创新
              </p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
      </ul>
    </div>
    <div class="industry web">
      <div class="industry-circle"></div>
      <div class="industry-content">
        <div class="industry-title">
          <p class="title-first">行业洞察，迈入新商业时代</p>
          <p class="title-third">以AI颠覆传统商业认知，高效、精准、低运维</p>
        </div>
        <ul class="indu-list indu-list-wrap marginTop">
          <li v-for="(item, index) in caseNameList" :key="index">
            <img
              @mouseover="caseEnter(index)"
              :src="require('../assets/images/icon/' + item.imgUrl + '.png')"
              alt=""
            />
            <p>{{ item.name }}</p>
          </li>
        </ul>
        <ul class="desc-template">
          <li>
            <p class="title">{{ caseDataList[activeIndex].caseTypeName }}</p>
            <p class="details">
              <span
                v-for="(d, dindex) in caseDataList[activeIndex].detaisName"
                :key="dindex"
                >{{ d }} <br
              /></span>
            </p>
          </li>
          <li>
            <p class="title">
              成功案例 |{{ caseDataList[activeIndex].custName }}
            </p>
            <p class="details">
              {{ caseDataList[activeIndex].custdetails }}
            </p>
            <span class="blue-btn desc-btn" style="display: none"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="industry-wrap wrap">
      <p class="tech-title1">行业洞察，迈入新商业时代</p>
      <p class="tech-title2">以AI颠覆传统商业认知，高效、精准、低运维</p>
      <ul>
        <li v-for="(item, index) in caseNameList1" :key="index">
          <img
            :src="require('../assets/images/icon/' + item.imgUrl + '.png')"
            alt=""
          />
          <p>{{ item.name }}</p>
        </li>
      </ul>
    </div>
    <div class="cooperate web">
      <div class="content-center">
        <div class="cooperate-title">
          <p class="title-first margin-bottom-20">信赖我们的合作伙伴</p>
        </div>
        <div class="cooperate-item">
          <div class="desc-swiper">
            <p class="swiper-title">{{ friendist[friendIndex].firendName }}</p>
            <p
              class="swiper-desc"
              v-for="(fd, dindex) in friendist[friendIndex].firendDesc"
              :key="dindex"
            >
              {{ fd }}<br />
            </p>
          </div>
          <div class="desc-video">
            <img
              :src="
                require('../assets/images/cooperate/' +
                  friendist[friendIndex].lagerImgUrl +
                  '.png')
              "
              alt=""
              style="max-width: 900px; max-height: 400px"
            />
          </div>
        </div>
        <ul class="cooperate-list">
          <li v-for="(f, index) in friendist" :key="index">
            <img
              @mouseover="friendEnter(index)"
              :src="require('../assets/images/cooperate/' + f.imgUrl + '.png')"
              alt=""
              style=""
            />
          </li>
        </ul>
        <div class="cooperate-swiper-list">
          <el-carousel :interval="5000" arrow="never">
            <el-carousel-item
              v-for="(item, index) in friendBrandList"
              :key="index"
            >
              <ul class="list-inner">
                <li
                  v-for="(logoNameitem, index) in item.logoNameList"
                  :key="index"
                >
                  <img
                    :src="
                      require('../assets/images/cooperate/' +
                        logoNameitem +
                        '.png')
                    "
                    alt=""
                  />
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="cooperate-wrap wrap">
      <p class="tech-title1 margin-bottom-20">信赖我们的合作伙伴</p>
      <ul>
        <li v-for="(f, index) in friendist" :key="index">
          <img
            :src="require('../assets/images/cooperate/' + f.imgUrl + '.png')"
            alt=""
          />
          <p
            class="corp-desc"
            v-for="(fd, dindex) in f.firendDesc"
            :key="dindex"
          >
            {{ fd }}
          </p>
          <div class="video-wrap">
            <img
              :src="
                require('../assets/images/cooperate/' + f.lagerImgUrl + '.png')
              "
              alt=""
              style="max-height: 200px"
            />
          </div>
        </li>
      </ul>
      <el-carousel :interval="5000" arrow="never" class="wrap">
        <el-carousel-item v-for="(item, index) in friendBrandList" :key="index">
          <ul class="list-inner">
            <li v-for="(logoNameitem, index) in item.logoNameList" :key="index">
              <img
                :src="
                  require('../assets/images/cooperate/' + logoNameitem + '.png')
                "
                alt=""
              />
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      class="footer-main"
      :style="{
        backgroundImage:
          'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
      }"
    >
      <div class="content-center web">
        <div class="footer-box">
          <div class="footer-left">
            <ul class="item-box">
              <li class="footer-item1">
                <span
                  >加入我们：liuxinyu@jiyu-ai.com<br />
                  商务合作：chentianyu@jiyu-ai.com<br />
                  技术支持：liqiangjian@jiyu-ai.com<br />
                  联系电话：13916027955<br />
                  公司地址：上海市浦东新区龙阳路2277号永达国际大厦9楼903室
                </span>
              </li>
              <li data-v-2f6d6da0="" class="footer-item1">
                <span
                  >联系电话：13916027955<br />
                  公司地址：辽宁省铁岭市银州区柴河街道卧龙馨园1幢1-12(二层)
                </span>
              </li>
              <li data-v-2f6d6da0="" class="footer-item1">
                <span
                >联系电话：13916027955<br />
                  公司地址：河南省驻马店市新蔡县弥陀寺乡林场西街派出所北100米40号
                </span>
              </li>
            </ul>
          </div>
          <ul data-v-2f6d6da0="" class="footer-right">
            <li data-v-2f6d6da0="">
              <img
                data-v-2f6d6da0=""
                src="../assets/images/code/wechat.jpg"
                alt=""
              />
              <p data-v-2f6d6da0="">霁宇智能公众号</p>
            </li>
          </ul>
        </div>
        <div class="copy-right">
          <span
            >Copyright © 2026 上海霁宇智能信息科技有限公司 All Rights Reserved ·
            <a
              href="http://www.beian.miit.gov.cn"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </span>
          <span>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502015630"
              target="_blank"
              rel="noopener noreferrer"
              >沪ICP备2025152194号-2 </a
            ></span
          >
        </div>
      </div>

      <p class="wrap copy-text">
        Copyright © 2026 上海霁宇智能信息科技有限公司 All Rights Reserved ·
      </p>
    </div>
    <div class="right-fix-pop web"></div>
  </div>
</template>

<script>
import $ from "jquery"; //在需要使用的页面中
export default {
  data() {
    return {
      activeIndex: 0,
      friendIndex: 0,
      caseNameList: [
        {
          name: "人力资源",
          imgUrl: "More1",
        },
        {
          name: "采购管理",
          imgUrl: "Multiple",
        },
        {
          name: "财务管理",
          imgUrl: "Openanaccount",
        },
        {
          name: "库存管理",
          imgUrl: "Safety",
        },
        {
          name: "审计风控",
          imgUrl: "transaction",
        },
        {
          name: "销售管理",
          imgUrl: "wallet",
        },
      ],
      caseNameList1: [
        {
          name: "人力资源",
          imgUrl: "More1",
        },
        {
          name: "采购管理",
          imgUrl: "Multiple1",
        },
        {
          name: "财务管理",
          imgUrl: "Openanaccount1",
        },
        {
          name: "库存管理",
          imgUrl: "Safety1",
        },
        {
          name: "审计风控",
          imgUrl: "transaction1",
        },
        {
          name: "销售管理",
          imgUrl: "wallet1",
        },
      ],
      caseDataList: [
        {
          caseTypeName: "人力资源",
          custName: "慧穗数字科技",
          detaisName: [
            "员工数据维护",
            "离职信息维护",
            "薪酬/福利账实核对",
            "个税申报",
            "培训提醒",
            "offer生产及发放",
          ],
          custdetails:
            "据安永会计师事务所的研究表明，人力资源部门员工大约有93％的时间都花费在重复性的工作上。65％的人力资源流程有可能实现自动化。上海霁宇通过OP RPA技术帮助慧穗数字科技解决了从员工入职，人力资源核对到个税申报，薪酬核算等一系列机器人自动流程操作。这也意味着人力资源专业人员可以更高效、更快捷地为企业，为员工提供人力资源服务。",
        },
        {
          caseTypeName: "采购管理",
          custName: "云汉芯城",
          detaisName: [
            "供应商数据库维护",
            "采购台账与系统数据核对",
            "应付账款提醒",
            "开票信息提供",
          ],
          custdetails:
            "云汉芯城作为国内电子行业领先的互联网平台，上游联接供应厂商近千家，下游注册用户数超过30万家。其采购部门承担着巨大的工作压力和人力成本，通过RPA对其供应商发票处理流程进行改造和梳理，实现自动接收读取供应商发票，整理比对发票中的型号，产地，数量，规格，价格等重要数据。并和云汉ERP系统进行无缝对接，避免人工处理时的出错概率和大大减少人力成本。",
        },
        {
          caseTypeName: "财务管理",
          custName: "世茂集团",
          detaisName: [
            "会计科目维护",
            "会计凭证处理",
            "对账",
            "发票验真及认证",
            "纳税申报",
            "银企对账",
            "固定资产数据维护",
            "营收稽核",
            "收款提醒",
            "结账",
          ],
          custdetails:
            "世茂集团的财务共享中心人员编制400多人，日常处理从SAP系统或其他的业务系统中导入导出各种数据，以完成税务、报销、对账、资金支付、汇款，收入等各方面工作。繁杂的工作使人员长期超负荷运转，以至于加班成了财务中心工作人员的家常便饭，月底时候还经常会通宵加班。使用OP机器人后，可以24小时不间断的自动处理这些工作，彻底将人力从繁杂的机械性劳动中解放出来，同时也大大提高了各项工作的准确性，极大地增加了员工的工作幸福感！",
        },
        {
          caseTypeName: "库存管理",
          custName: "湘商贸易",
          detaisName: [
            "物料数据维护:库存数据维护",
            "物流系统与库存数据核对",
            "报告",
          ],
          custdetails:
            "上海湘商通过RPA解决了人工操作物流单号上传、发货等问题。订单数量多数据相似度高，人工操作很容易视觉疲惫引起失误，而RPA可以减少因人为操作带来的失误风险，降低跨系统数据传输/搬运带来的错误。并且7*24小时处理任务，工作时间延长，效率大大提高。解决了因订单多人力效率低的问题，不改动现有系统，降低企业开发成本，减少人力资源浪费。",
        },
        {
          caseTypeName: "审计风控",
          custName: "赛诺菲医药",
          detaisName: [
            "按规则抽样",
            "审计信息核对",
            "流程合规检查",
            "流程分析",
            "报告",
          ],
          custdetails:
            "赛诺菲的质检系统通过上传的录音来检测录音的质量是否达标，而这个上传的过程是刻板且具有重复性的。通过RPA机器人能更好的为业务场景提供最高效的服务，能够代替人工解决了重复性的工作，而且可以7*24小时不间断的工作。RPA机器人能够每天对自己的工作进行一个汇总，用户能够更直观的看到上传录音的完成进度。",
        },
        {
          caseTypeName: "销售管理",
          custName: "巴斯夫",
          detaisName: [
            "客户数据维护",
            "销售台账自动维护",
            "销售台账与系统数据核对",
            "返利价差数据维护",
            "信用数据维护",
            "应收账款提醒",
            "自动开票",
            "月结",
          ],
          custdetails:
            "巴斯夫通过RPA实现了24小时自动监控手机端的销售订单反馈给销售人员，并及时发送给生产部门。节省了销售合同的签订到落实生产的时间，提高完成定单效率，并保证了不同部门传输数据时产品型号、合作公司和销售人员的准确性。",
        },
      ],
      friendist: [
        {
          imgUrl: "shimfo_img_logo",
          firendName: "商业地产世贸集团",
          firendDesc: [
            "全国50+酒店自动晨报",
            "亚太报表汇总效率提升300%",
            "亚太财务表效率提升250%，正确率100%",
          ],
          lagerImgUrl: "shimfo_img",
        },
        {
          imgUrl: "sainuofei",
          firendName: "赛诺菲医药",
          firendDesc: ["正确率100%", "业财数据核对效率提升300%", "节省10人/月"],
          lagerImgUrl: "sanofi",
        },
        {
          imgUrl: "ickey_logo",
          firendName: "云汉芯城集团",
          firendDesc: [
            "自动订单下达",
            "自动处理发票数据",
            "效率提升350%",
            "正确率100%",
            "节省35人/月",
          ],
          lagerImgUrl: "ickey_img",
        },
        {
          imgUrl: "pharmeyes_logo",
          firendName: "倍通医药",
          firendDesc: [
            "自动大会/小会费用审计核算",
            "商贸尽调自动助手",
            "医师自动信息背调",
            "效率提升500%",
          ],
          lagerImgUrl: "pharmeyes_img",
        },
      ],
      bannerList: [
        {
          imgUrl: "banner1",
        },
        {
          imgUrl: "banner2",
        },
        {
          imgUrl: "banner3",
        },
      ],
      bannerwrapList: [
        {
          imgUrl: "banner_wrap1",
        },
        {
          imgUrl: "banner_wrap2",
        },
        {
          imgUrl: "banner_wrap3",
        },
      ],
      friendBrandList: [
        { logoNameList: ['0-1','0-2', '0-3', '0-4', '0-5',1, 2, 3, 4, 5, 6, 7, 8] },
        { logoNameList: [9, 10, 11, 12, 13, 14, 15, 17] },
        { logoNameList: [17, 18, 19, 20, 21, 22, 23, 24] },
      ],
      menuShowFlag: "display: none;",
      menuShowIndex: 0,
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    openList() {
      if (this.menuShowIndex == 0) {
        this.menuShowFlag = "display: block;";
        this.menuShowIndex = 1;
      } else {
        this.menuShowFlag = "display: none;";
        this.menuShowIndex = 0;
      }
    },
    caseEnter(index) {
      this.caseNameList[this.activeIndex].imgUrl = this.caseNameList[
        this.activeIndex
      ].imgUrl.replace("1", "");
      this.activeIndex = index;
      this.caseNameList[index].imgUrl =
        this.caseNameList[this.activeIndex].imgUrl + "1";
    },
    friendEnter(index) {
      this.friendIndex = index;
    },
    downloadIndex(id) {
      if (id == 1) {
        //直接跳转
        this.$router.push({ path: "/product" });
      } else {
        this.$router.push({ path: "/contact" });
      }
    },
  },
  // require引用：
  mounted() {

  },
};
</script>
<style scoped>
</style>
